import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./styles/index.css";
import { ThemeProvider } from "./components/ui/theme-provider";
import { ErrorBoundaryForwardRef } from "./components/ErrorBoundaryForwardRef";

// Vérification critique avec retry
const ensureReactReady = () => {
  let attempts = 0;
  const maxAttempts = 10;
  
  const checkReact = () => {
    attempts++;
    if (typeof React !== 'undefined' && React.forwardRef) {
      console.log("✅ React ready after", attempts, "attempts");
      return true;
    }
    
    if (attempts >= maxAttempts) {
      console.error("❌ CRITICAL: React.forwardRef still not available after", maxAttempts, "attempts");
      throw new Error("React.forwardRef not available - chunking issue");
    }
    
    console.warn("⚠️ React.forwardRef not ready, attempt", attempts, "retrying...");
    return false;
  };
  
  return checkReact();
};

if (!ensureReactReady()) {
  throw new Error("React initialization failed");
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("❌ Root element not found!");
  throw new Error("Root element not found");
}

console.log("🎯 Creating React root...");
createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundaryForwardRef>
      <ThemeProvider defaultTheme="light" storageKey="singu-ui-theme">
        <App />
      </ThemeProvider>
    </ErrorBoundaryForwardRef>
  </StrictMode>
);

console.log("✅ React app rendered successfully");